import WeeklyPatientLimit from "./WeeklyPatientLimit";

export default WeeklyPatientLimit;
